export const storeRoutes = {
  root: '/store',
};
